class CartOfferManager {
  constructor() {
    this.threshold  = 3;
    this.offerPrice = 1698;
    this.targetTag  = 'regular-fit';
    this._timer     = null;
    this.init();
  }

  init() {
    document.addEventListener('cart:updated', () => this.debounce());
    this.observeCartDrawer();
    this.updateOffer();
  }

  debounce() {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => this.updateOffer(), 300);
  }

  observeCartDrawer() {
    const observer = new MutationObserver(() => this.debounce());
    const target =
      document.getElementById('CartDrawer-CartItems') ||
      document.getElementById('cart-drawer-items');
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  async getCartData() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  isTee(item) {
    const raw = item.product_tags || item.tags || '';
    return raw
      .toLowerCase()
      .split(',')
      .map(t => t.trim())
      .includes(this.targetTag);
  }

  async updateOffer() {
    const cart = await this.getCartData();

    const teeItems         = cart.items.filter(item => this.isTee(item));
    const teeCount         = teeItems.reduce((sum, item) => sum + item.quantity, 0);
    const teeOriginalTotal = teeItems.reduce(
      (sum, item) => sum + item.original_line_price / 100, 0
    );
    const savings = Math.round(teeOriginalTotal - this.offerPrice);
    const needed  = this.threshold - teeCount;

    this.updateBannerUI(teeCount, savings, needed);
    this.updateSavingsMsg(teeCount, savings);
  }

  updateBannerUI(count, savings, needed) {
    const banner = document.getElementById('cart-offer-banner');
    if (!banner) return;

    const { offerPrice } = this;

    if (count >= this.threshold) {
      banner.innerHTML = `
        <div class="offer-banner offer-banner--applied">
          <span class="offer-icon">🎯</span>
          <span class="offer-text">
            <strong>BUY ANY 3 TEES @ ₹${offerPrice}</strong> offer applied!
          </span>
        </div>
        <div class="offer-success-box">
          <div class="offer-success-header">
            <span class="offer-success-icon">🎉</span>
            <span><strong>BUY ANY 3 TEES @ ₹${offerPrice}</strong> — Saved ₹${savings}</span>
          </div>
          <p class="offer-success-msg">
            Congrats! 'Buy any 3 Tees @ ₹${offerPrice}' applied successfully
          </p>
        </div>`;

    } else if (count > 0) {
      banner.innerHTML = `
        <div class="offer-banner offer-banner--progress">
          <span class="offer-icon">🛍️</span>
          <span class="offer-text">
            Add <strong>${needed} more Regular Fit Tee${needed > 1 ? 's' : ''}</strong>
            &amp; get all 3 @ ₹${offerPrice}!
          </span>
        </div>`;

    } else {
      banner.innerHTML = `
        <div class="offer-banner offer-banner--default">
          <span class="offer-icon">🛍️</span>
          <span class="offer-text">
            Buy any <strong>3 Regular Fit Tees @ ₹${offerPrice}</strong>!
          </span>
        </div>`;
    }
  }

  updateSavingsMsg(count, savings) {
    const el = document.querySelector('.cart-yay-savings');
    if (!el) return;
    if (count >= this.threshold) {
      el.innerHTML = `Yay! You save <strong>₹${savings}</strong> on this order`;
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartOfferManager = new CartOfferManager();
});